<template>
	<v-container grid-list-md class="fill-height" fluid>
		<v-row align="center" justify="center">
			<v-col cols="12" sm="8" md="4">
				<app-error-alert></app-error-alert>
				<ValidationObserver ref="obs" v-slot="{ invalid }">
					<v-form>
						<v-card class="elevation-12">
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title class="text-center">
									<v-spacer></v-spacer>
									{{ $t("Login to your account") }}
									<v-spacer></v-spacer
								></v-toolbar-title>
							</v-toolbar>
							<v-card-text>
								<ValidationProvider
									name="email"
									rules="required|email"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										:label="$t('Email')"
										v-model="item.email"
										prepend-icon="mdi-account"
										type="email"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
								<ValidationProvider
									name="password"
									rules="required|min:8"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										:label="$t('label.password')"
										v-model="item.password"
										prepend-icon="mdi-lock"
										type="password"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
								<v-checkbox
									v-model="item.remember"
									:label="$t('label.remember_me')"
								></v-checkbox>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<Link :href="$route('password.request')">
									<v-btn text>{{
										$t("label.forgot_password")
									}}</v-btn></Link
								>
								<v-spacer></v-spacer>
								<v-btn
									color="primary"
									@click.native="login()"
									:loading="item.processing"
									:disabled="invalid"
								>
									<v-icon left>mdi-login</v-icon>
									{{ $t("label.login") }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</ValidationObserver>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { Link } from "@inertiajs/inertia-vue";
	import LayoutGuest from "../../layouts/guest.vue";
	export default {
		layout: LayoutGuest,

		components: {
			Link,
		},

		data() {
			return {
				item: this.$inertia.form({
					email: null,
					password: null,
					remember: false,
				}),
			};
		},

		methods: {
			login() {
				this.item.post(this.$route("login"), {
					onFinish: () => this.item.reset("password"),
				});
			},
		},
	};
</script>